import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {ResponseData} from '../nest-responses';
import {
  RequestEaList,
  RequestEaListComponent,
  RequestEAProcess,
  ResponseEaList,
  ResponseEaListComponent,
  ResponseEaYear,
} from './ea-setting.dto';

@Injectable()
export class EaSettingApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'ea-setting';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public ealistcomponent(payload: RequestEaListComponent): Observable<ResponseData<ResponseEaListComponent[]>> {
    const method: string = 'GET';
    const func: string = 'ealistcomponent';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseEaListComponent[]>>(method, url, params, urlParams, body);
  }

  public ealist(payload: RequestEaList): Observable<ResponseData<ResponseEaList[]>> {
    const method: string = 'GET';
    const func: string = 'ealist';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseEaList[]>>(method, url, params, urlParams, body);
  }

  public eaprocess(payload: RequestEAProcess[]): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'eaprocess';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public eaYear(): Observable<ResponseData<ResponseEaYear[]>> {
    const method: string = 'GET';
    const func: string = 'eaYear';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseEaYear[]>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/ea-setting.api.ts